import React from "react";
import { downloadRoomTemplate } from "../../../services/section";
import BaseModal from "components/BaseModal";
import {
  Container,
  Row,
  Col,
  Alert,
} from "react-bootstrap";

const DownloadRoomTemplateModal = ({
  onCloseModal,
  open,
}) => {
  const submitHandler = async (e) => {
    e.preventDefault();
    const response = await downloadRoomTemplate()

    const url = window.URL.createObjectURL(
      new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download',
        "room_template.xlsx");
    document.body.appendChild(link);
    link.click();
    handleCloseModal();
  };

  const handleCloseModal = () => {
    onCloseModal();
  }

  return (
    <BaseModal
      onSubmit={submitHandler}
      onClose={handleCloseModal}
      show={open}
      title={"Download Room Template"}
      submitButtonText={"Download"}
      formWrapper={true}
      size={"lg"}
      content={
        <>
          <Container fluid>
                <Alert
                    variant="info"
                >
                    <p><b>Info</b></p>
                    <ul>
                      <li>Questions will be copied from the Room Type </li>
                      <li>Additional features are imported from this list. Note multiple features can be listed on subsequent lines.</li> 

                      <li>If a room type doesn’t exist an error message shows to user and the room is not imported.</li> 
                      <li>Cleaner should be matched by name</li> 
                    </ul>
                </Alert>
          </Container>
        </>
      }
    />
  );
};
export default DownloadRoomTemplateModal;
